import { Stack } from "@mui/material";
import { useEffect, useState } from "react";

import { formatFileSize } from "../utils/general";
import { cn } from "../utils/styling";
import { IconButton } from "./IconButton";

export const ApiFileRow = ({
  className,
  file,
  isImage = true,
  removeFile,
}: {
  className?: string;
  file: { name: string | undefined; src: string | undefined };
  isImage?: boolean | undefined;
  removeFile: () => void;
}) => {
  return (
    <FileRowBase
      className={className}
      isImage={isImage}
      name={file.name}
      previewUrl={file.src}
      removeFile={removeFile}
      size={undefined}
    />
  );
};

const FileRowBase = ({
  className,
  isImage = true,
  name,
  previewUrl,
  removeFile,
  size,
}: {
  className?: string;
  isImage?: boolean | undefined;
  name?: string;
  previewUrl?: string;
  removeFile: () => void;
  size?: number | undefined;
}) => {
  const sizeText = formatFileSize(size);
  return (
    <Stack className={cn("w-full justify-between rounded-md bg-white px-3 py-2 border-ds-subtle", className)}>
      <Stack className="min-w-0 flex-1 flex-row items-center">
        {isImage && (
          <>
            {previewUrl ? (
              <img alt={name} className="h-10 w-10 rounded-sm object-cover" src={previewUrl} />
            ) : (
              <div className="h-10 w-10 rounded-sm bg-lds-surface-muted" />
            )}
          </>
        )}
        <div className="ml-3 min-w-0">
          <p className="truncate font-ds-body-regular-md ">{name}</p>
          {sizeText != null && <p className="text-lds-foreground-secondary font-ds-body-regular-xs">{sizeText}</p>}
        </div>
      </Stack>
      <IconButton
        buttonProps={{ onClick: removeFile, size: "sm", variant: "tertiary" }}
        iconProps={{ iconName: "Close", size: "sm" }}
      />
    </Stack>
  );
};

export const LocalFileRow = ({
  className,
  file,
  isImage = true,
  removeFile,
}: {
  className?: string;
  file: File;
  isImage?: boolean | undefined;
  removeFile: () => void;
}) => {
  const [blobUrl, setBlobUrl] = useState<null | string>(null);

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setBlobUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  return (
    <FileRowBase
      className={className}
      isImage={isImage}
      name={file.name}
      previewUrl={blobUrl ?? ""}
      removeFile={removeFile}
      size={file.size}
    />
  );
};
